package com.macrofocus.nastac.components

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.nastac.ViewStyle
import mui.material.*
import mui.material.Size
import mui.material.styles.TypographyVariant
import mui.system.sx
import org.mkui.react.toState
import react.FC
import react.PropsWithChildren
import react.create
import react.dom.events.MouseEvent
import react.dom.html.ReactHTML
import react.use
import web.cssom.*
import web.html.HTMLElement

external interface ViewStyleAccordionProps : PropsWithChildren {
    var viewStyle: ViewStyle
    var viewStyleProbing: MutableProperty<ViewStyle?>
    var viewStyleSelection: MutableProperty<ViewStyle>
    var viewStyleExpansion: MutableProperty<ViewStyle>
}

val ViewStyleAccordion = FC<ViewStyleAccordionProps> { props ->
    val nastac = use(NASTACContext)!!

    val viewStyle = props.viewStyle

    val (viewStyleSelected, setViewStyleSelected) = props.viewStyleSelection.toState()
    val layerVisibleProperty = viewStyle.layerVisible(nastac.dataLoader)
    val layerVisible = if(layerVisibleProperty != null) layerVisibleProperty.toState().component1() else null
    val excludeLayerVisible: List<MutableProperty<Boolean>>? = viewStyle.excludeLayerVisible(nastac.dataLoader)

    val (viewStyleExpanded, _) = props.viewStyleExpansion.toState()

    val expanded = viewStyleExpanded == viewStyle

    if (viewStyle.visible) {
        val group = viewStyle.description == null || viewStyle == ViewStyle.TILLY

        ReactHTML.div {
            //            to = "flow"

//                    css {
//                        textDecoration = None.Companion.none
//                        color = Color.Companion.currentcolor
//                    }

            Accordion {
                sx {
                    backgroundColor = Color.transparent
                    boxShadow = None.none

                    minHeight = if(group) 36.px else 28.px
                    ".MuiAccordionSummary-root" {
                        minHeight = if(group) 36.px else 28.px
                        "&.Mui-expanded" {
                            minHeight = if(group) 36.px else 28.px
                        }
                    }
                    "&.Mui-expanded" {
                        minHeight = if(group) 36.px else 28.px
                    }
                    ".MuiAccordionSummary-content" {
                        margin = 0.px
                        "&.Mui-expanded" {
                            margin = 0.px
                        }
                    }
                    "&.Mui-disabled" {
                        backgroundColor = Color.transparent
                    }
                }

                key = viewStyle.toString()
                //                                selected = lastPathname == key
                this.expanded = expanded
                disabled = !viewStyle.isEnabled(viewStyleSelected)

                onChange = { _, expanded ->
                    if(expanded) {
//                        setViewStyleSelected(viewStyle)
                        props.viewStyleExpansion.value = viewStyle

                        if(layerVisible != null) {
                            if (excludeLayerVisible != null) {
                                excludeLayerVisible.forEach {
                                    it.value = false
                                }
                                layerVisibleProperty?.value = true
                            }
                        }
                    }
                }

                onClick = {
                    props.viewStyleSelection.value = viewStyle
                }

                onMouseEnter = { event: MouseEvent<HTMLElement, *> ->
                    props.viewStyleProbing.value = viewStyle
                }

                onMouseLeave = { event: MouseEvent<HTMLElement, *> ->
                    props.viewStyleProbing.value = null
                }

                AccordionSummary {
                    sx {
                        backgroundColor = if(viewStyleSelected == viewStyle) rgb(255, 255, 0, 0.15) else Color.transparent

                        // Style the expandIcon wrapper
                        "& .MuiAccordionSummary-expandIconWrapper" {
//                                    transition = Transition.transform(0.3.s, Easing.ease)
                            transform = rotate(0.deg)
                        }
                        "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper" {
                            transform = rotate(22.5.deg)
                            filter = dropShadow(2.px, 2.px, 3.px, rgb(255, 255, 0, 0.9))
                        }

                        if(!group) {
                            marginLeft = 8.px
                        }
                    }

                    if(group) {
                        expandIcon = viewStyle.icon.create {
                        }
                    } else {
                        expandIcon = null

                        +viewStyle.icon.create()
                    }

                    if(layerVisible != null) {
                        if(excludeLayerVisible != null) {
//                            FormControlLabel {
//                                label = ReactNode("Option B")
//                                control = Radio.create {
                            Radio {
                                sx {
                                    paddingTop = 2.px
                                }

                                size = Size.small
                                checked = layerVisible
                                onChange = { _, _ ->
                                    excludeLayerVisible.forEach {
                                        it.value = false
                                    }
                                    layerVisibleProperty?.value = true
                                }
//                                }
                            }
                        } else {
                            Switch {
                                size = Size.small

                                checked = layerVisible
                                onChange = { _, checked ->
                                    layerVisibleProperty?.value = checked
                                }
                            }
                            }
                    }

                    Typography {
                        sx {
                            if(group) {
                                marginLeft = 5.px
                            }
                            whiteSpace = WhiteSpace.nowrap
                            if(group) {
                                fontWeight = FontWeight.bold
                            }
                        }

                        +viewStyle.toString()
                    }
                }
                if(viewStyle.description != null) {
                    AccordionDetails {
                        sx {
                            backgroundColor = if(viewStyleSelected == viewStyle) rgb(255, 255, 0, 0.05) else Color.transparent

                            paddingTop = 4.px
                            paddingBottom = 4.px
                            paddingLeft = 26.px
                            paddingRight = 12.px
                            gap = 2.px
                        }

                        Typography {
                            variant = TypographyVariant.body1
                            gutterBottom = true
                            align = TypographyAlign.justify

                            sx {
//                                fontFamily = "'EB Garamond', serif".unsafeCast<FontFamily>()
//                                fontWeight = "500".unsafeCast<FontWeight>()
                                fontSize = 0.95.em
//                            color = rgb(111, 23, 25)
                                whiteSpace = WhiteSpace.preLine
                                lineHeight = number(1.0)
                            }

                            +viewStyle.description
                        }
                    }
                }
            }
        }
    }
}